import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import theme from "../theme/theme";
import ButtonComponent from "./ButtonComponent";
import { requestProfileUpdateAsync } from "../services/employeeService";
import MySpinner from "./MySpinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseISO, format } from "date-fns";
import showSweetAlert from "./SweetAlert";
import { useNavigate } from "react-router-dom";
import { routePath } from "../routes/routePath";

const EmpEditProfile = ({
  formData,
  handleInputChange,
  qualifications,
  nationalities,
  employee,
  handlePhoneChange,
  handlePhoneBlur,
}) => {
  const collegEmail = "oc.edu.sa";

  const getUsernameFromEmail = (email, domain) => {
    if (!email || typeof email !== "string") return "";
    return email.endsWith(`@${domain}`) ? email.split("@")[0] : "";
  };
  const formattedEmail = getUsernameFromEmail(employee.email, collegEmail);

  const [loading, setLoading] = useState(false);
  const [profileRequests, setProfileRequests] = useState(false);
  const [error, setError] = useState("");
  const [userEmail, setUserEmail] = useState(formattedEmail);
  const navigate = useNavigate();

  const formatDateForBackend = (dateString) =>
    new Date(dateString).toISOString();

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const newEmail = `${userEmail}@${collegEmail}`;

    setLoading(true);
    try {
      const payload = {
        employeeId: employee.id,
        oldData: {
          name: employee.name,
          qualificationId: employee.qualificationId,
          nationalityId: employee.nationalityId,
          phone: employee.phone,
          email: employee.email,
          idNumber: employee.idNumber,
          birthDate: employee.birthDate,
          gender: employee.gender,
        },
        proposedData: {
          name: formData.name,
          qualificationId: formData.qualificationId,
          nationalityId: formData.nationalityId,
          phone: formData.phone,
          email: newEmail,
          idNumber: formData.idNumber,
          birthDate: formatDateForBackend(formData.birthDate),
          gender: formData.gender,
        },
      };
      const response  = await requestProfileUpdateAsync(payload);
      if (response.result === false){
        setError(response.message);
      }
      else {
        showSweetAlert(response.message, () => {
          window.location.reload();
        });
      }
    } catch (error) {
      setError(error.message);
      setProfileRequests(true);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const requiredFields = [
      "name",
      "qualificationId",
      "nationalityId",
      "phone",
      "idNumber",
      "gender",
      "birthDate"
    ];

    for (let field of requiredFields) {
      const value = formData[field];
      if (field === "phone" && (!value || value.length !== 10)) {
        setError("رقم الجوال يجب ان يكون 10 ارقام فقط وبدأ ب 05");
        return false;
      }

      if (field === "idNumber" && (!value || value.length !== 10)) {
        setError("رقم الهوية/الاقامة يجب ان يكون 10 ارقام فقط");
        return false;
      }

      
      if (
        (field === "qualificationId" || field === "nationalityId") &&
        (!value || value === 0)
      ) {
        setError("يجب اختيار جنسية و مؤهل");
        return false;
      }

      if (field === "gender" && (!value || (value !== "male" && value !== "female"))) {
        setError("يجب اختيار الجنس");
        return false;
      }

      
      if (
        (field === "birthDate" ) &&
        (!value || value === 0)
      ) {
        setError("يجب ادخال تاريخ الميلاد");
        return false;
      }

      

      // Email checks
      if (!userEmail.trim()) {
        setError("البريد الإلكتروني مطلوب.");
        return false;
      }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const email = `${userEmail}@${collegEmail}`;
 
        if (!emailRegex.test(email)) {
          setError("البريد الإلكتروني غير صالح.");
          return false;
        }
         
      }
     

    setError("");
    return true;
  };

  const isFieldEmpty = (field) => !formData[field];
  return (
    <div className="profile-container shadow-box col-12 d-flex flex-column align-items-center p-4 m-auto">
      <div className="profile-header d-flex flex-column align-items-center mb-4">
        <FontAwesomeIcon icon={faUser} fontSize={50} className="mb-3" />
        <h2 className="mb-1">{formData.name}</h2>
        <p style={{ color: theme.colors.darkGray }}>
          <span>الاقسام/المناصب: </span>
        </p>
        <ul className="department-positions-list">
          {/* Dept/Positions aren't editable, so still display */}
        </ul>
      </div>

      <div className="profile-info container col-sm-10 col-12 mb-4">
        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">الاسم : </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className={`form-control ${
              isFieldEmpty("name") ? "is-invalid" : ""
            }`}
          />
        </div>

        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">الجنس: </label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            className={`form-control ${
              isFieldEmpty("gender") ? "is-invalid" : ""
            }`}
          >
            <option value="">اختر</option>
            <option value="male">ذكر</option>
            <option value="female">أنثى</option>
          </select>
        </div>

        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">الجنسية: </label>
          <select
            name="nationalityId"
            value={formData.nationalityId || ""}
            onChange={handleInputChange}
            className={`form-control ${
              isFieldEmpty("nationalityId") ? "is-invalid" : ""
            }`}
          >
            <option value="" disabled>
              اختر
            </option>
            {nationalities && nationalities.length > 0 ? (
              nationalities.map((n) => (
                <option key={n.nationalityId} value={n.nationalityId}>
                  {n.name}
                </option>
              ))
            ) : (
              <option value="" disabled>
                جار التحميل ...
              </option>
            )}
          </select>
        </div>

        <div className="info-row d-flex flex-column flex-sm-row justify-content-start shadow-box p-3 mb-3">
          <label className="w-25"> تاريخ الميلاد : </label>
    
          <DatePicker
            className="form-control"
            selected={formData.birthDate ? parseISO(formData.birthDate) : null}
            onChange={(date) =>
              handleInputChange({
                target: {
                  name: "birthDate",
                  value: date ? date.toISOString() : "",
                },
              })
            }
            dateFormat="dd/MM/yyyy"
            placeholderText="dd/mm/yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
           />
            
        </div>

        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">رقم الهوية/الإقامة: </label>
          <input
            type="text"
            name="idNumber"
            value={formData.idNumber}
            onChange={handleInputChange}
            className={`form-control ${
              isFieldEmpty("idNumber") ? "is-invalid" : ""
            }`}
          />
        </div>

        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">اخر مؤهل: </label>
          <select
            name="qualificationId"
            value={formData.qualificationId}
            onChange={handleInputChange}
            className={`form-control ${
              isFieldEmpty("qualificationId") ? "is-invalid" : ""
            }`}
          >
            {qualifications && qualifications.length > 0 ? (
              qualifications.map((q) => (
                <option key={q.qualificationId} value={q.qualificationId}>
                  {q.qualificationName}
                </option>
              ))
            ) : (
              <option value="">جار التحميل ...</option>
            )}
          </select>
        </div>
        <div className="info-row d-flex flex-column flex-sm-row justify-content-between shadow-box p-3 mb-3">
          <label className="w-25">رقم الجوال: </label>
          <input
            type="text"
            name="phone"
            placeholder="05XXXXXXXX"
            value={formData.phone}
            onChange={handlePhoneChange}
            onBlur={handlePhoneBlur}
            className={`form-control ${
              isFieldEmpty("phone") ? "is-invalid" : ""
            }`}
          />
        </div>

        <div className="info-row d-flex flex-column flex-sm-row   justify-content-start align-items-baseline  shadow-box p-3 mb-3">
          <label className="w-25">البريد الإلكتروني:</label>
          <div className="d-flex align-items-baseline justify-content-start w-75">
            <label className="ms-2" dir="ltr">
              @{collegEmail}
            </label>
            <input
              type="text"
              name="userEmail"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
              className={`form-control ${!userEmail.trim() ? "is-invalid" : ""}`}
              // className={`form-control ${isFieldEmpty("email") ? "is-invalid" : ""}`}
              placeholder="email"
            />
          </div>
        </div>

        {error && (
          <div className="alert alert-warning">
            {error}
            {profileRequests && (
              <button
                className="btn btn-sm secondary-bg text-light mx-2"
                onClick={() => navigate(routePath.empRequests(employee.id))}
              >
                طلباتي
              </button>
            )}
          </div>
        )}
        <div>
          {loading ? (
            <MySpinner />
          ) : (
            <>
              <ButtonComponent
                text="إرسال طلب"
                className="primary-bg mx-2"
                onClick={handleSubmit}
              />
              <ButtonComponent
                text="الغاء"
                className="bg-secondary text-light mx-2"
                onClick={() => window.location.reload()}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmpEditProfile;
